<script lang="ts">
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import type {Labeled} from 'typings/portaro.be.types';
    import {asFlattenedTreeListNode, isFlattenedTreeListNode} from 'shared/utils/types-utils';

    export let option: Labeled;
    export let usedAsLabel = false;

    $: isTreeNode = isFlattenedTreeListNode(option);

    // TODO:
    // function treeGraphElementsToText(value: FlattenedTreeListNode): string {
    //     return value.treeGraphElements
    //         .map((type) => {
    //             switch (type) {
    //                 case 'L_JUNCTION':
    //                     return 'L->';
    //                 case 'T_JUNCTION':
    //                     return '|->';
    //                 case 'SPACE':
    //                     return '   ';
    //                 case 'LINE':
    //                     return '|  ';
    //             }
    //         })
    //         .reduce((acc, val) => acc + val, '');
    // }
</script>

{#if usedAsLabel || !isTreeNode}
    {pipe(option, loc())}
{:else}
<!--    <span class="hierarchy-graph">-->
<!--        {treeGraphElementsToText(asFlattenedTreeListNode(option))}-->
<!--    </span>-->
    <span class="hierarchy-offset-container" style="--depth-level: {asFlattenedTreeListNode(option).depth}">
        {pipe(option, loc())}
    </span>

{/if}

<style lang="less">
    .hierarchy-offset-container {
        padding-left: calc(3ch * var(--depth-level, 0));
    }

    //.hierarchy-graph {
    //    white-space: pre;
    //    font-family: monospace
    //}
</style>